import InviteAdmin from '@/admin/InviteAdmin.vue';
import Login from '@/auth/Login.vue';
import ClientReport from '@/clientReport/ClientReport.vue';
import ClientInvite from '@/clients/ClientInvite.vue';
import Clients from '@/clients/Clients.vue';
import UploadEmployeeData from '@/employeeData/UploadEmployeeData.vue';
import ExportSurveys from '@/export/ExportSurveys.vue';
import UnmappedDatapoints from '@/mapping/UnmappedDatapoints.vue';
import UnmappedQuestionTypes from '@/mapping/UnmappedQuestionTypes.vue';
import Reports from '@/reports/Reports.vue';
import Survey from '@/surveys/Survey.vue';
import SurveyTemplateUpload from '@/surveyTemplates/SurveyTemplateUpload.vue';
import Router from 'vue-router';
import { CurrentUser, UserRole, UserService } from './UserService';

export const createRouter = (userService: UserService) => {
  const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
      { path: '*', redirect: '/login' },
      {
        path: '/clients',
        alias: '/home',
        name: 'clients',
        component: Clients,
        props: {
          featureFlagClientInvite:
            process.env.VUE_APP_FEATURE_CLIENT_INVITE === 'true',
        },
      },
      {
        path: '/clients/:id/invite',
        name: 'clientInvite',
        component: ClientInvite,
      },
      {
        path: '/export',
        name: 'export',
        component: ExportSurveys,
      },
      {
        path: '/invite',
        name: 'invite',
        component: InviteAdmin,
      },
      {
        path: '/login',
        name: 'login',
        component: Login,
      },
      {
        path: '/mapping/datapoints',
        name: 'mapping-datapoints',
        component: UnmappedDatapoints,
      },
      {
        path: '/mapping/question-types',
        name: 'mapping-question-types',
        component: UnmappedQuestionTypes,
      },
      {
        path: '/reports',
        name: 'reports',
        component: Reports,
      },
      {
        path: '/surveys/:id',
        name: 'surveys',
        component: Survey,
      },
      {
        path: '/survey-templates',
        name: 'surveyTemplates',
        component: SurveyTemplateUpload,
      },
      {
        path: '/upload-employee-data',
        name: 'uploadEmployeeData',
        component: UploadEmployeeData,
      },
      {
        path: '/report',
        name: 'report',
        component: ClientReport,
        props: (aRoute) => ({ clientId: aRoute.meta.clientId }),
      },
    ],
  });

  router.beforeEach(async (to, from, next) => {
    const user = await userService.resolve();
    to.meta.clientId = user.clientId;
    next(route(to.path, user));
  });

  return router;
};

const route = (to: string, user: CurrentUser): string | undefined => {
  const loginRoute = to === '/login';
  const reportRoute = to === '/report';
  const noRedirect = undefined;

  switch (user.role) {
    case UserRole.LOGGED_OUT:
      return !loginRoute ? '/login' : noRedirect;
    case UserRole.CLIENT_ADMIN:
      return loginRoute || !reportRoute ? '/report' : noRedirect;
    case UserRole.HOLISTIC_ADMIN:
      return loginRoute || reportRoute ? '/home' : noRedirect;
    default:
      throw new Error('unrecognized roles');
  }
};
